export const LANGUAGES = [
  { key: "es", label: "Español" },
  { key: "en", label: "English" },
  { key: "ro", label: "Română" }
];
